import React from 'react'
import { CSSTransition } from 'react-transition-group'
import cx from 'classnames'

import styles from './FadeScale.module.scss'

type FadeScaleProps = {
  children?: React.ReactNode
  className?: string
  timeout?: React.ComponentProps<typeof CSSTransition>['timeout']
  isInitialised?: boolean
}

export const FadeScale = React.forwardRef<HTMLElement, FadeScaleProps>(
  (
    { children, className, timeout = { enter: 500, exit: 0 }, isInitialised },
    ref,
  ) => (
    <CSSTransition
      className={cx(className)}
      classNames={{
        enter: styles.enter,
        enterActive: styles.enterActive,
        exit: styles.exit,
        exitActive: styles.exitActive,
      }}
      // CSSTransition needs an object ref to read `.current`. Every caller
      // passes one; the forwardRef signature just can't express that.
      nodeRef={ref as React.RefObject<HTMLElement>}
      timeout={timeout}
      in={isInitialised}
      mountOnEnter
      unmountOnExit
    >
      {children}
    </CSSTransition>
  ),
)
